export const ROOM_TYPES = [
  'Kök',
  'Sovrum',
  'Vardagsrum',
  'Källare',
  'Garage',
  'Vind',
  'Annat rum'
];

export default ROOM_TYPES; 